
export type ThemePalette = {
    name: string;
    label: string;
    colors: {
        background: string;
        foreground: string;
        card: string;
        cardForeground: string;
        popover: string;
        popoverForeground: string;
        primary: string;
        primaryForeground: string;
        secondary: string;
        secondaryForeground: string;
        muted: string;
        mutedForeground: string;
        accent: string;
        accentForeground: string;
        destructive: string;
        destructiveForeground: string;
        border: string;
        input: string;
        ring: string;
    };
};

export const themes: Record<string, ThemePalette> = {
    cyber: {
        name: 'cyber',
        label: 'Cyberpunk Neon',
        colors: {
            background: '0 0% 4%',
            foreground: '0 0% 95%',
            card: '0 0% 8%', // Glassy dark
            cardForeground: '0 0% 95%',
            popover: '0 0% 6%',
            popoverForeground: '0 0% 95%',
            primary: '157 100% 50%', // Neon Green
            primaryForeground: '0 0% 0%',
            secondary: '0 0% 12%',
            secondaryForeground: '0 0% 90%',
            muted: '0 0% 15%',
            mutedForeground: '0 0% 55%',
            accent: '180 100% 50%', // Cyan
            accentForeground: '0 0% 0%',
            destructive: '0 90% 60%',
            destructiveForeground: '0 0% 100%',
            border: '0 0% 18%',
            input: '0 0% 15%',
            ring: '157 100% 50%',
        },
    },
    sunset: {
        name: 'sunset',
        label: 'Miami Sunset',
        colors: {
            background: '260 40% 5%', // Deep purple tint
            foreground: '260 20% 95%',
            card: '260 30% 10%',
            cardForeground: '260 20% 95%',
            popover: '260 30% 8%',
            popoverForeground: '260 20% 95%',
            primary: '320 100% 60%', // Hot Pink
            primaryForeground: '0 0% 100%',
            secondary: '260 20% 15%',
            secondaryForeground: '260 20% 90%',
            muted: '260 20% 20%',
            mutedForeground: '260 10% 60%',
            accent: '30 100% 60%', // Orange
            accentForeground: '0 0% 0%',
            destructive: '0 90% 60%',
            destructiveForeground: '0 0% 100%',
            border: '260 20% 20%',
            input: '260 20% 15%',
            ring: '320 100% 60%',
        },
    },
    deepSpace: {
        name: 'deepSpace',
        label: 'Deep Space',
        colors: {
            background: '222 47% 4%', // Very dark blue
            foreground: '210 40% 98%',
            card: '222 47% 8%',
            cardForeground: '210 40% 98%',
            popover: '222 47% 6%',
            popoverForeground: '210 40% 98%',
            primary: '217 91% 60%', // Electric Blue
            primaryForeground: '0 0% 100%',
            secondary: '217 32% 17%',
            secondaryForeground: '210 40% 98%',
            muted: '217 32% 17%',
            mutedForeground: '215 20% 65%',
            accent: '262 83% 58%', // Purple
            accentForeground: '0 0% 100%',
            destructive: '0 62% 30%',
            destructiveForeground: '210 40% 98%',
            border: '217 32% 17%',
            input: '217 32% 17%',
            ring: '224 76% 48%',
        },
    },
    gold: {
        name: 'gold',
        label: 'Luxurious Gold',
        colors: {
            background: '0 0% 5%', // Black
            foreground: '45 20% 95%',
            card: '0 0% 10%',
            cardForeground: '45 20% 95%',
            popover: '0 0% 8%',
            popoverForeground: '45 20% 95%',
            primary: '45 93% 47%', // Gold
            primaryForeground: '0 0% 0%',
            secondary: '0 0% 15%',
            secondaryForeground: '45 10% 90%',
            muted: '0 0% 20%',
            mutedForeground: '45 10% 60%',
            accent: '45 50% 60%', // Light Gold
            accentForeground: '0 0% 0%',
            destructive: '0 90% 60%',
            destructiveForeground: '0 0% 100%',
            border: '45 30% 20%',
            input: '45 20% 15%',
            ring: '45 93% 47%',
        },
    },
};

export const applyTheme = (themeName: string) => {
    const theme = themes[themeName] || themes.cyber;
    const root = document.documentElement;

    Object.entries(theme.colors).forEach(([key, value]) => {
        // Convert camelCase to kebab-case (e.g., cardForeground -> --card-foreground)
        const cssVar = `--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
        root.style.setProperty(cssVar, value);
    });
};
